import styled from "styled-components";
import { Result, Button, Typography, Layout } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
  padding: 16px;
  @media (max-width: 576px) {
    padding: 0;
  }
`;

const StyledContent = styled(Content)`
  padding: 24px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  width: 100%;
  max-width: 500px;
`;

const StyledTitle = styled(Title)`
  color: #1c8dc9;
  font-size: 28px;
  margin-bottom: 16px;

  @media (max-width: 576px) {
    font-size: 24px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  font-size: 16px;
  margin-bottom: 24px;

  @media (max-width: 576px) {
    font-size: 14px;
  }
`;

const StyledButton = styled(Button)`
  background-color: #1c8dc9;
  border-color: #1c8dc9;

  &:hover,
  &:focus {
    background-color: #1a7eb5;
    border-color: #1a7eb5;
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`;

const StyledResult = styled(Result)`
  .ant-result-icon {
    margin-bottom: 24px;
  }
  @media (max-width: 576px) {
    padding: 0;
  }

  .ant-result-icon > .anticon {
    font-size: 72px;

    @media (max-width: 576px) {
      font-size: 56px;
    }
  }
`;

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <StyledLayout>
      <StyledContent>
        <StyledResult
          status="404"
          title={<StyledTitle>Page non trouvée</StyledTitle>}
          subTitle={
            <StyledParagraph>
              Désolé, la page que vous recherchez n'existe pas ou a été
              déplacée.
            </StyledParagraph>
          }
          extra={
            <StyledButton
            style={{backgroundColor: "#1c8dc9", borderColor: "#1c8dc9"}}
              type="primary"
              icon={<HomeOutlined />}
              onClick={() => navigate("/")}
            >
              Retour à l'accueil
            </StyledButton>
          }
        />
      </StyledContent>
    </StyledLayout>
  );
}
